import React, { useState } from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import firebase from 'firebase/app';
import { Position,  Intent, Toaster } from "@blueprintjs/core";


const AppToaster = Toaster.create({
    className: "cta",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Call To Action Updated", intent: Intent.SUCCESS, timeout: 1000});
}
function CallToActionModal({
    setShowCTA,
    showCTA,
    callToAction,
    profile
}) {

    const [ cta, setCTA ] = useState(callToAction)

    // console.log(callToAction)

    const submitChange = () =>{
        firebase
        .firestore()
        .collection('organizations')
        .doc(profile.company)
        .collection('CTA')
        .doc(profile.company)
        .set({
            CTA: cta
        })
        .then(() =>{
            setShowCTA(false)
            showToast()
        })
    }

    return (
    <Transition.Root show={showCTA} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        // initialFocus={completeButtonRef}
        open={showCTA}
        onClose={setShowCTA}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div>
                <div className="mt-1 text-left">
                  <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                    Edit Call To Action
                  </Dialog.Title>
                  {/* <div className="mt-2 mb-4">
                      Yo
                  </div> */}
                  <div
                  className="my-4"
                  >
                      <p className="text-base mb-1">
                          Current Call To Action: 
                      </p>
                      <textarea 
                      defaultValue={cta}
                      className="p-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring resize-none h-24 w-full"
                      onChange={(e) => setCTA(e.target.value)}
                      />
                  </div>
                  <div
                  className="flex"
                  >
                    <button
                    onClick={() => submitChange()}
                    className="p-2 rounded-lg bg-green-600 text-white hover:bg-greeb-800 focus:outline-none"
                    >
                        Accept Edit
                    </button>
                    <button
                    className="ml-3 p-2 rounded-lg bg-gray-600 text-white hover:bg-gray-800 focus:outline-none"
                    onClick={() => setShowCTA(false)}
                    >
                        Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
    )
}

export default CallToActionModal
